export default class NoPasswordFormErrors {
  auth = {
    login: null
  }

  authRequirements = []

  captcha = {
    resolve: null,
    token: null,
    type: null
  }

  captchaRequirements = []

  user = {
    email: null,
    phone: null,
    blocked: null
  }

  user_access = {
    attempts: null,
    date_generation: null
  }

  constructor (object) {
    const auth = object?.auth ?? {}
    let authKey = Array.isArray(auth) ? 'authRequirements' : 'auth';
    Object.assign(this[authKey], auth)

    const captcha = object?.captcha ?? {}
    let captchaKey = Array.isArray(captcha) ? 'captchaRequirements' : 'captcha';
    Object.assign(this[captchaKey], captcha)

    Object.assign(this.user, object?.user ?? {})
    Object.assign(this.user_access, object?.user_access ?? {})
  }
}
